<template>
  <td class="text-center align-middle">
    <span
      v-if="entry && entry.mixed"
      class="small text-muted text-nowrap"
      :title="$t('exchangeRates.columns.mixedHint')"
    >{{ $t("exchangeRates.columns.mixed") }}</span>
    <button
      v-else-if="entry"
      type="button"
      class="btn btn-sm py-0 px-1 tabular-nums text-nowrap"
      :class="buttonClass"
      :disabled="isSystem || isShared"
      :title="buttonTitle"
      @click="$emit('open', entry.currencyId, entry.shippingId || null)"
    >
      <i
        class="fas me-1"
        :class="entry.source === 'manual' ? 'fa-lock-open' : 'fa-lock'"
        aria-hidden="true"
      ></i>
      {{ entry.rate ? formatRate(entry.rate) : "—" }}
    </button>
  </td>
</template>

<script>
/**
 * Celda «T. cambio» de una fila del Operation Balance (ticket #397): muestra el tipo de
 * cambio con que la operación lleva esa moneda a la del sistema y abre el modal.
 * En la moneda del sistema el botón queda deshabilitado (1). En la PI, una fila que junta
 * varios embarques muestra el tipo de cambio si coincide (se cambia desde cada embarque)
 * o «Varios» si no.
 */
export default {
  name: "OperationExchangeRateCell",
  props: {
    /**
     * Fila de `fx.rates` (o { rate: 1, source: 'system' } para la moneda del sistema), con
     * `shippingId` en la PI, `shared` si es de varios embarques o `mixed` si no coinciden.
     */
    entry: { type: Object, default: null },
  },
  computed: {
    isSystem() {
      return !!this.entry && this.entry.source === "system";
    },
    isShared() {
      return !!this.entry && !!this.entry.shared;
    },
    buttonTitle() {
      if (this.isSystem) return this.$t("exchangeRates.columns.systemCurrency");
      if (this.isShared) return `${this.sourceLabel} · ${this.$t("exchangeRates.columns.sharedHint")}`;
      return `${this.sourceLabel} · ${this.$t("exchangeRates.columns.rateHint")}`;
    },
    buttonClass() {
      if (!this.entry) return "";
      if (this.isSystem) return "btn-outline-secondary";
      if (this.entry.missing || !this.entry.rate) return "btn-outline-danger";
      if (this.entry.source === "manual") return "btn-outline-warning";
      return "btn-outline-primary";
    },
    sourceLabel() {
      const e = this.entry || {};
      if (e.source === "manual") return this.$t("exchangeRates.source.manual");
      if (e.source === "frozen") return this.$t("exchangeRates.source.frozen");
      if (e.source === "settings")
        return this.$t("exchangeRates.source.settings");
      if (e.source === "official") {
        return e.official && e.official.source === "frankfurter"
          ? this.$t("exchangeRates.source.frankfurter")
          : this.$t("exchangeRates.source.bcra");
      }
      return this.$t("exchangeRates.source.missing");
    },
  },
  methods: {
    formatRate(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return "—";
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      });
    },
  },
};
</script>
